import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Row, Col, Divider , Modal} from "antd";
import {
  CancelButton,
  SaveButton,
  ProfileMobileCard,
  RadioButtonContainer,
  MobileCardHeadingItems,
  MobileCardHeadingItemsValue,
  ModalButtonContainer,
  MobileCardHeading,
  DefaultIndicator,
  MyProfileTableCardView,
} from "../../styles";
import { showComponent, tableDataSuccess } from "../../actions";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../utils/sessionUtil";
import { recordError } from "../../../../utils/commonUtil";
import { accountChange } from "../../../../actions/globalActions";
import moment from 'moment';
import PropTypes from 'prop-types';
import { selectAccountID } from "../../../../selectors/globalSelectors";
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";

class RadioCardComponent extends Component {
  state = {
    currentItemId: undefined,
    value: "",
    radioIndex: "",
    updatedRadioData: [],
    disable: true,
    accountId: "",
    selectedOption: { accountID: "" },
    grayedOut:true
  };

  onRadioChange = e => {
    this.setState({
      value: e,
      disable: false,
      grayedOut:false
    });
  };

  handleOk = e => {

    const { onAccountChange } = this.props;

    this.setState({
      modalVisible: false
    });

    onAccountChange({
      accountID: this.state.accountId.toString()
    });    

  };

  handleDefaultClick = () => {
    this.props.history.push({
      pathname: '/'
    })
  }

  showModal = value => {
    this.setState({
      modalVisible: true,
      accountId: value
    });
  };

  handleCancel = e => {
    this.setState({
      modalVisible: false
    });
  };

  changeDefaultRow = () => {
    this.state.prevCardData= this.props.RadioCardData.find((item) => item.primary == 1);
    this.props.RadioCardData.forEach(obj => {
      if (obj.accountId === this.state.value) {
        obj.primary = "1";

        this.state.updatedRadioData.push(obj);
      } else {
        obj.primary = "0";
        this.state.updatedRadioData.push(obj);
      }
    });
  };

  componentDidMount() {
    (() => {
      this.props.RadioCardData.forEach((item, index) => {
        if (item.primary === "1") {
          document.querySelectorAll("input[name=radio-group]")[
            index
          ].checked = true;
        }
      });
    })();
  }
  postData = () => {
    this.setState({grayedOut:true})
    this.changeDefaultRow();
    const metaData = {
      method: "FORMDATA",
      url: `/donor-portal/api/profile/${getAccountData().partyId}/changeDefaultAccount`,
      page: "myProfile",
      data: {
        fromAccId: this.state.prevCardData.accountId,
        toAccId : this.state.value
      }
    };
    this.props.tableDataSuccess({
      changeDef: this.props.changeDefault,
      metaData
    });
  };

  render() {
    const { RadioCardData, fromCsrUser } = this.props;
    
    let DefaultRadioValue = -1;
    RadioCardData.forEach((item, index) => {
      if (item.primary == "1") {
        DefaultRadioValue = index;
      }
    });   

    return (
      <div>
        {RadioCardData.map((obj, index) => {
          return (
            <div key={obj.accountNumber}>
              <ProfileMobileCard
                id={"rdAccountInfo"+ index}
                cardIndex={index}
                activeCard={this.state.currentItemId === index ? true : false}
                className="mobileCard"
              >
                <Row>
                  <Col sm={2} xs={2}>
                    <div className="container">
                      <input
                        data-test="InputContainer"
                        type="radio"
                        name="radio-group"
                        value={obj.accountNumber}
                        onChange={() => this.onRadioChange(obj.accountId)}
                      />
                      <span className="checkmark" />
                    </div>
                  </Col>
                  <Col sm={22} xs={22}>
                    <Row>
                      {obj.primary == "1" ? (
                <div>
                  <MyProfileTableCardView
                    data-test="myProfileAccountNameMob"
                    className="myProfileAccountNameMob" 
                    onClick={() => { 
                      try {
                        if(getPrimaryAccount().userId == obj.accountId)
                          this.handleDefaultClick();
                        else
                          this.showModal(obj.accountId);
                      } catch (error) {
                        recordError(error);
                      }
                    }}>
                    {obj.accountName}
                  </MyProfileTableCardView>
                  <DefaultIndicator>Default</DefaultIndicator>
                </div>
              ) : (
                <div>
                  <MyProfileTableCardView
                    data-test="myProfileAccountNameMob1"
                    className="myProfileAccountNameMob"
                    onClick={() => {
                      try {
                        if(getPrimaryAccount().userId == obj.accountId)
                          this.handleDefaultClick();
                        else
                          this.showModal(obj.accountId);
                      } catch (error) {
                        recordError(error);
                      }
                    }}
                  >
                    {obj.accountName}
                  </MyProfileTableCardView>
                </div>
              )}
                    </Row>
                    <Row>
                      <Col sm={12} xs={12}>
                        <MobileCardHeadingItems>
                          Account Number
                        </MobileCardHeadingItems>{" "}
                        <MobileCardHeadingItemsValue>
                          {obj.accountNumber}
                        </MobileCardHeadingItemsValue>
                      </Col>
                      <Col sm={12} xs={12}>
                        <MobileCardHeadingItems>
                          Date Opened{" "}
                        </MobileCardHeadingItems>{" "}
                        {
                          obj.dateOpened
                          && <MobileCardHeadingItemsValue>
                            {moment(moment.tz(parseInt(obj.dateOpened), "America/New_York")).format("MM-DD-YYYY")}                    
                          </MobileCardHeadingItemsValue>
                        }
                        {
                          !obj.dateOpened
                          && <MobileCardHeadingItemsValue> -- </MobileCardHeadingItemsValue>
                        }
                      </Col>
                    </Row>
                    <Divider type="horizontal" />
                    <Row>
                      <Col sm={12} xs={12}>
                        <MobileCardHeadingItems>Role</MobileCardHeadingItems>{" "}
                        <MobileCardHeadingItemsValue>
                          {obj.role}
                        </MobileCardHeadingItemsValue>
                      </Col>
                      <Col sm={12} xs={12}>
                        <MobileCardHeadingItems>
                          Access Level
                        </MobileCardHeadingItems>{" "}
                        <MobileCardHeadingItemsValue>
                          {obj.access}
                        </MobileCardHeadingItemsValue>
                      </Col>
                    </Row>
                    <Divider type="horizontal" />
                    <Row>
                      <Col sm={12} xs={12}>
                        <MobileCardHeadingItems>Balance</MobileCardHeadingItems>{" "}
                        <MobileCardHeadingItemsValue>                          
                          {"$" +
                            Number(obj.balance).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                          )}
                        </MobileCardHeadingItemsValue>
                      </Col>
                      <Col sm={12} xs={12} />
                    </Row>
                    <Divider type="horizontal" />
                  </Col>
                </Row>
              </ProfileMobileCard>
            </div>
          );
        })}

        <RadioButtonContainer>          
          <GeneralButton
            data-test="RadioButtonContainer1"
            type="functional"
            text="Cancel"
            disabled={false}
            inverted={true}
            mobWidth="9.375rem"
            maxWidth="991px"
            id="btnAccountInfoCancel"
            mobMargin="0px"
            onClick={() => {
              try {
                this.props.showComponent();
                this.props.toggleisEnabled();
                this.props.analyticsTracking('cancel', this.props.eventaction(), 'Cancel');
              } catch (error) {
                recordError(error);
              }
            }}
          />
          { 
            <GeneralButton
              data-test="RadioButtonContainer2"
              type="functional"
              text="Save"
              disabled={this.state.grayedOut}
              inverted={false}
              mobWidth="9.375rem"
              maxWidth="991px"
              id="btnAccountInfoSave"
              mobMargin="0px"
              onClick={() => {
                try {
                  this.postData();
                  this.props.toggleisEnabled();
                  this.props.analyticsTracking('save', this.props.eventaction(), 'Save');
                } catch (error) {
                  recordError(error);
                }
              }}
              disabled={isGeminiUser() ? (fromCsrUser ? false : true ) : false}
              className={this.state.disable}
          />
          }
        </RadioButtonContainer>
        {RadioCardData.map(obj => {
          if (this.state.accountId === obj.accountId) {
            return (
              <Modal
                title="Switch Account"
                visible={this.state.modalVisible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={[
                  <ModalButtonContainer>
                    <GeneralButton
                      text="Cancel"
                      id="btnPopupCancel"
                      onClick={this.handleCancel}
                      type="functional"
                      width="9.375rem"
                      inverted={true}
                      disabled={false}
                    />
                    <GeneralButton
                      text="Continue"
                      id="btnPopupContinue"
                      onClick={this.handleOk}
                      type="functional"
                      width="9.375rem"
                      inverted={false}
                      disabled={false}
                    />
                  </ModalButtonContainer>
                ]}
              >
                <p>
                  You are about to switch to account {obj.accountName}{" "}
                  <b>{obj.accountNumber}</b>
                  <br />
                  This will take you to the account page.
                  <br />
                  Do you want to continue?
                </p>
              </Modal>
            );
          }
        })}
      </div>
    );
  }
}

RadioCardComponent.propTypes = {
  eventaction: PropTypes.func,
  analyticsTracking: PropTypes.func,
  RadioCardData: PropTypes.arrayOf(PropTypes.object),
  toggleisEnabled: PropTypes.func,
  fromCsrUser: PropTypes.bool
}

const mapStateToProps = state => ({
  accountID: selectAccountID(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  tableDataSuccess: data => dispatch(tableDataSuccess(data)),
  showComponent: () => dispatch(showComponent()),
  onAccountChange: data => dispatch(accountChange(data))  
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RadioCardComponent)
);
